/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { PipelineColumnHeader as ECPipelineColumnHeader } from '@blend/enterprise-components';
import { PipelineStateContext } from './PipelineStateContext';

export const PipelineColumnHeader: React.FC<Pick<
  ECPipelineColumnHeader.Props,
  'fetchPipelineLoans' | 'column' | 'columnSchema'
>> = props => {
  const {
    state: {
      sortObj: { sortDir, sortField },
    },
    updateSortObj,
  } = React.useContext(PipelineStateContext);

  return (
    <ECPipelineColumnHeader sortDir={sortDir} sortField={sortField} updatePipelineSortObj={updateSortObj} {...props} />
  );
};
